(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["no-react-stack"] = factory(require("react"));
	else
		root["no-react-stack"] = factory(root["React"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__787__) {
return 